import { MutationTree } from "vuex";
import {
  IPassage,
  IQuestion,
  IContentQuizSection,
  IContentSection,
  IContentState,
} from "@/store/modules/content/types";

type ContentMutationsTree = MutationTree<IContentState>;

export const mutations: ContentMutationsTree = {
  setContentSection(
    state: IContentState,
    section: IContentSection | IContentQuizSection
  ) {
    state.section = section;
  },

  setContentQuestions(state: IContentState, questions: IQuestion[]) {
    state.questions = questions;
  },

  setContentPassages(state: IContentState, passages: IPassage[]) {
    state.passages = passages;
  },
};
